import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/assets/js/axiosExtend.js'
import Tool, { handleLocalStorage } from '@/assets/js/utils.js'
import Router from '@/router'
import cookie from 'js-cookie'
import { Message } from 'element-ui'
import i18n from '@/lang'

Vue.use(Vuex)

const domainArray = document.domain.split('.')
const domainLength = domainArray.length
const domain = `.${domainArray[domainLength - 2]}.${domainArray[domainLength - 1]}`

export default new Vuex.Store({
  state: {
    asRoleList: [],
    languageType: '',
    logo: `${$cm.logo}`,
    homeLogo: require(`@/${$cm.homeLogo}`),
    logoGray: require(`@/${$cm.logoGray}`),
    meetingId: '',
    loginInfo: {},
    partyCode: '',
    logoTitle: `${$cm.commonLogoTitle}`,
    commonLogo: `${$cm.commonLogo}`,
    rArray: [],
    config: {
      joinLink: undefined
    },
    participantRole: 0,
    talkBackInfo: {},
    isMute: false,
    slotList: [],
    ccIdList: [],
    currentRtilCode: '',
    crewInfo: {},
    privateInfo: {},
    privateInfoByOthers: [], // 多host模式下，记录其它host的私聊信息
    pgmStream: null,
    controlInfo: {},
    groupInfo: null, // 用于查询当前是否有在send
    hadPullStream: false,
    joinInfo: null, // 用于查询其他页面是否有send VFB的
    pageSerBusRequestWs: {},
    joinId: '',
    rtcClient: {},
    groupLayout: { layout: 7, column: 7 },
    originRtil: '',
    targetRtil: '',
    talkInfo: null,
    speakerInfo: null,
    questionerInfo: {},
    gallerySpeakerInfo: null,
    galleryBroadcastInfo: null,
    raiseHandPrivateInfo: null,
    gallery6x24index: 1,
    galleryAllGroupRtilCodes: [],
    v3List: [], // 用来保存所选择的V3列表
    currentPartyInfo: {},
    galleryChannels: {}, // 为了raiseHand里面能拿到流
    galleryExternalChannels: {},
    galleryPartyCodeList: [],
    partyJoinInfo: {},
    resolutionRange: {
      '180p': {
        range: [0, 140],
        bitrateRange: [100, 200],
        width: 320,
        height: 180,
        fps: 15
      },
      '360p': {
        range: [140, 500],
        bitrateRange: [400, 600],
        width: 640,
        height: 360,
        fps: 30
      },
      '720p': {
        range: [500, 1130],
        width: 1280,
        height: 720,
        bitrateRange: [2000, 2300],
        fps: 30
      },
      '1080p': {
        range: [1130],
        width: 1920,
        height: 1080,
        bitrateRange: [3000, 3200],
        fps: 30
      }
    },
    roleType: {
      1: 'coordinator',
      2: 'reporter',
      3: 'questioner',
      4: 'speaker',
      5: 'questionSpeaker'
    },
    galleryCurrentRtilCodes: [],
    outputCode: '',
    hasVideo: true,
    hasAudio: true,
    haveCamera: true,
    pageLoading: false, // 用于check接口的i请求loading，加载loading页面
    hadLoadPartyList: false, // 用来配合显示页面 loading 的
    newPageLoading: false, // 用于页面整体全屏
    checkEnv: {},
    tabConfig: {
      commonParty: { label: 'Partyline', name: 'party', ref: 'partyList', component: 'party-list' },
      gallery: { label: 'Gallery View', name: 'group', ref: 'partyList', component: 'party-list' },
      conference: { label: 'Conference', name: 'coordinator', ref: 'partyList', component: 'coordinator-party-list' },
      newConference: { label: 'Conference', name: 'newCoordinator', ref: 'partyList', component: 'coordinator-party-list' },
      kiosk: { label: 'Kiosk Mode', name: 'kiosk', ref: 'kiosk', component: 'kiosk-party-list' },
      globalControl: { label: 'Global Control', name: 'globalControl', ref: 'globalControl', component: 'global-party-list' }
    },
    batchMoveParticipate: false, // 用于判断是否开启批量moveParty功能,放在state里保证后进入的与会者，也可以同步操作
    batchMoveParticipateList: [], // 获取所有可以move的rtilCode，用于判断selectall按钮，是否可以选中
    layoutConfig: {
      '1-2': '1x2',
      '2-2': '2x2',
      '2-4': '2x4',
      '3-3': '3x3',
      '2-5': '2x5',
      '4-4': '4x4',
      '5-4': '5x4',
      '5-5': '5x5',
      '4-8': '4x8',
      '5-7': '5x7',
      '4-9': '4x9',
      '6-6': '6x6',
      '6-7': '6x7',
      '7-7': '7x7',
      '8-8': '8x8'
    },
    webrtc: null,
    parOnlineInfo: {}, // 用来记录与会者在线信息的
    partyCodeList: [], // 用来记录当前模式下的所有partyCode
    hadSelectUpLogo: [],
    selectLogoInfo: {}, // 用来记录之前所存的logo信息，不然每次加载侧边组件会覆盖值
    showUploadLogo: false,
    allowAudio: false, // 为了commentator页面显示音量柱的
    hadSelectUpBg: {},
    activeName: 'Logo', // 用来显示隐藏新模式全屏下的done按钮
    channelMode: {
      '-1': 'UNKNOWN',
      0: 'COMMON',
      1: 'GALLERY',
      2: 'CONFERENCE',
      3: 'EXTERNAL',
      4: 'SCENE',
      7: 'CANVAS',
      8: 'SECTION',
      9: 'COMMENTATOR_PARENT',
      12: 'COMMENTATOR',
      13: 'KIOSK',
      17: 'Global'
    },
    kioskSideBarInfo: {
      position: 'right',
      width: 150,
      height: 727
    },
    hasKioskSideBar: false,
    showChat: false,
    rtcList: {},
    channelModeByRouteName: {
      0: 'party',
      1: 'group',
      2: 'coordinator',
      4: 'arena',
      12: 'commentator',
      13: 'kiosk',
      18: 'station'
    },
    commonHostLeftRight: false,
    showConferenceLocal: false,
    deviceType: '',
    audioType: 2,
    checkMainWindow: true,
    checkShareScreen: true,
    inAudioOnlyStatus: false,
    volumeInfo: {},
    browserLanguage: 'en',
    isMac: false,
    isAndroid: false,
    showFootBar: true,
    hadInvitedList: '',
    hadInvitedCoHostList: [],
    participateChannelMode: {
      0: 'party',
      1: 'channel',
      2: 'reporter',
      4: 'arena',
      12: 'commentator',
      13: 'kiosk',
      18: 'station'
    },
    buttonColor: {
      0: 'gray',
      1: 'green',
      2: 'red'
    },
    receiverNickname: '',
    audioMatrixEnable: false,
    audioMaTrixEnable: false,
    pushTalkEnable: false,
    intercomEnable: false,
    initPushToTalk: false,
    initAudioMatrixEnable: false,
    initIntercomEnable: false,
    audioMatrixFullScreen: false,
    globalNameInfo: {},
    matrixInfoMuteMap: {},
    matrixInfoUnTalkMap: {},
    haveUnReadMessage: true,
    fullScreen: false,
    talkbackStatus: false,
    deviceInfo: {},
    partiAudioMatrixEnable: false,
    isVertical: false,
    globalControlId: '',
    globalFullScreen: false,
    globalMute: false,
    ppRlist: [],
    ppConferenceRlist: [],
    ppGalleryRlist: [],
    isWebFullScreen: false,
    globalisFullScreen: 0,
    partyTag: '',
    isTag: '',
    soureTagType: '',
    rtilTagCode: '',
    receivedCohost: false,
    isSafari: false,
    networkConnect: true,
    currentModule: 'party',
    guideObjShow: false,
    selfVideo: true,
    selfAudio: true,
    intercom: 0,
    startPrivateInfo: {}, // 用来记录主动发起私聊的 rtilCode 因为这部分需要暂停他们声音的播放
    showInitCameraTips: false,
    initCamera: false,
    cameraName: '',
    anAvailbleDeviceId: '',
    cameraStatus: {},
    micStatus: {},
    deviceTypeMap: {},
    showAISpeech: false,
    aiSpeech: {
      running: false
    },
    productionId: '',
    showAIBot: false,
    aiBotFeature: false,
    aiBotEnable: false,
    aiBotCommandStatus: 0,
    currentSpeech: '',
    summaryInfo: {
      show: false,
      startTime: '',
      endTime: '',
      contentText: '',
      customTitle: true,
      loading: false,
      bottomText: 'voiceCommand.summaryTime',
      title: 'aiSpeech.aiSummary',
      save: 'authorizeOperation.ok',
      width: '500'
    },
    allRtilCodes: [],
    voiceCommandList: [],
    pushTalkOpen: false,
    participantPushTalkOpen: false,
    groupList: [],
    pressShortCut: 0,
    pushTalking: false,
    shortCutArray: {},
    currentPushTalkInfo: {},
    pushTalkRtilCodeList: [],
    searchDeviceInfo: {
      showDeviceTitle: true,
      sourceType: 'pack',
      condition: ''
    },
    sttSwitch: false,
    localSendPrivateArray: [], // 用来记录发起私聊的 rtilCode
    hasLogin: false,
    volumeBar: null,
    nickNameMap: {},
    changeSpeaker: false,
    speaker: true,
    talentConnectRtilCode: '',
    stationConnectRtilCode: '',
    publicPath: 'partyline',
    intercomPushTalk: false,
    intercomTalkToAllTalents: false,
    intercomTalkToHost: false,
    allSessionSpeakerInfo: {},
    drawer: false,
    localShareInfo: {},
    bindStationInfo: {},
    stationList: []
  },
  mutations: {
    config (state, val) {
      state.config = val
      state.webrtc = new Window.RtcClient()
      if (state.config.urlInfo && state.config.urlInfo.userAuthUrl) {
        Vue.prototype.$TVU = {
          http: axios,
          userGroup: 'https://' + state.config.versionControl.versionApiUrl,
          serverName: 'Partyline',
          userAuthUrl: state.config.urlInfo ? state.config.urlInfo.userAuthUrl : '' // 后端配置的url地址
        }
      }
      if (state.config.versionControl.versionUrl) {
        window.versionNewsObj = {
          code: state.config.versionControl.versionCode,
          pageSize: 10,
          versionUrl: 'https://' + state.config.versionControl.versionUrl,
          versionApiUrl: 'https://' + state.config.versionControl.versionApiUrl,
          theme: 'black'
        }
      }
    },
    saveLoginInfo (state, val) {
      state.loginInfo = val
      // appcues上报用户信息
      // window.Appcues.identify(val.id, {
      //   name: val.userName,
      //   email: val.email,
      //   firstName: val.firstName,
      //   lastName: val.lastName
      // })
    },
    showAllowAudio (state, val) {
      state.allowAudio = val
    },
    isMute (state, val) {
      state.isMute = val
    },
    setRtcClient (state, { key, client }) {
      state.rtcClient[key] = client
    },
    currentPartyInfo (state, val) {
      state.currentPartyInfo = Object.assign({}, state.currentPartyInfo, val)
    },
    pageLoading (state, val) {
      state.pageLoading = val
    },
    checkEnv (state, val) {
      state.checkEnv = val
    },
    jumpLoginPage (state) {
      // debugger
      cookie.remove('SID', { domain })
      handleLocalStorage('remove', 'partylineConfig')
      handleLocalStorage('remove', 'memberId')
      handleLocalStorage('remove', 'rtilCode')
      // 清除host登录的标记
      handleLocalStorage('remove', 'isHost')
      if (window.location.href.includes('joinOrStart')) {
        const userServerUrl = state.config.urlInfo?.userservice
        const serverName = state.config.serverName
        const publicPath = state.publicPath
        window.location.href = `${userServerUrl}/?url=${location.protocol}//${location.host}/${publicPath}/manage&serviceName=${serverName}`
      } else {
        Router.push({
          name: 'joinOrStart'
        })
      }
      state.loginInfo = {}
    },
    // 写入语言类型
    writeLanguageType (state, val) {
      state.languageType = val
    }
  },
  actions: {
    async checkEnv ({ commit, state }, { partyCode, passWord } = {}) {
      let type = ''
      // 由于cohost要follow的host的环境,目前切换会议也要check环境
      if (!partyCode || typeof (partyCode) != 'string') return
      // 检查 partyCode 中是否包含字母
      const hasLetters = /[a-zA-Z]/.test(partyCode)
      const illegalPartyCode = hasLetters ? partyCode : ''
      if (partyCode) partyCode = partyCode.replace(/[^0-9]/ig, '') // 过滤掉非数字字符
      if (partyCode.length > 20 || partyCode.length < 9) {
        Message.error(i18n.t('common.invalidPartyIdText'))
        return
      }
      commit('pageLoading', true)
      const params = {
        partyCode,
        clientType: 0
      }
      if (illegalPartyCode) {
        params._illegalPartyCode = illegalPartyCode
      }
      await axios
        .get('/partyline-backend/party/noLogin/check', { params, timeout: 10000, errorTip: false }).then(async res => {
          if (res.data.errorCode == '0x0') {
            commit('pageLoading', false)
            const result = res.data.result
            commit('checkEnv', result)
            if (!result.enable) {
              type = 'disableParty'
              Router.push({ name: 'remove', query: { type: 'disableParty' } })
            } else {
              // 判断是否是commentator的party
              if (result.channelModel == 12 && state.config.urlInfo.commentatorParty.includes('/commentator') && partyCode) {
                window.location.href = `${state.config.urlInfo.commentatorParty}?join_id=${partyCode}`
                type = 'redirect'
                return
              }
              const inviteMode = result.inviteMode
              // 判断当前环境是不是和check接口给的一致,默认设置需要更新环境
              result.updateEnv = true
              // 获取当前域名下的所有cookie
              const cookieList = cookie.get()
              Object.keys(cookieList).forEach(key => {
                if (result.tagKey == key && result.tagValue == cookieList[key]) {
                  result.updateEnv = false
                }
              })
              // 判断如果当前isLogin为false，则清除session
              if (!result.login) {
                cookie.remove('SID', { domain })
              }
              // remove tag cookies
              result.tagList && result.tagList.forEach(v => {
                if (v.tagKey != result.tagKey || v.tagValue != result.tagValue) {
                  Tool.setTagCookie(v.tagKey, v.tagValue, -1)
                }
              })
              // set Tag Cookies
              Tool.setTagCookie(result.tagKey, result.tagValue)
              // 如果party不存在，tagKey tagValue为空，则不更新环境直接跳转到start页面
              if (result.channelModel == -1) { // -1代表partyCode不存在，未被创建过
                Message.error(i18n.t('remainWords.enterId'))
                Router.push({ name: 'joinOrStart' })
                return
              }
              if (result.deleteFlag == 1) { // 1代表partyCode被删除
                Router.push({ name: 'remove', query: { type: 'disableParty' } })
                return
              }
              // 该party为登录者自己创建的party，跳转至host页面
              if ((result.owner || result.coHost) && !result.arriveMaximumOnlineCollaborate) {
                const routeName = state.channelModeByRouteName[result.channelModel]
                if (routeName) {
                  Router.push({
                    name: routeName,
                    query: {
                      id: partyCode
                    }
                  })
                  // 更新环境
                  if (result.updateEnv) {
                    window.location.reload()
                  }
                }
              } else {
                // 3代表是 passcode 模式需要验证密码
                if (inviteMode === 3) {
                  let haveHistoryMem = ''
                  if (result.channelModel == 1) {
                    haveHistoryMem = handleLocalStorage('get', 'galleryMemberId') || 'PL_' + new Date().getTime()
                  } else {
                    haveHistoryMem = handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime()
                  }
                  result.channelModel == 1 ? handleLocalStorage('set', 'galleryMemberId', haveHistoryMem) : handleLocalStorage('set', 'memberId', haveHistoryMem)
                  if (!partyCode) return
                  const params = {
                    partyCode,
                    invitePassCode: passWord,
                    memberId: haveHistoryMem
                  }
                  await axios
                    .post('/partyline-backend/partyExtendInfo/noLogin/checkInvite', params, { errorTip: false })
                    .then(res => { })
                } else {
                  // 更新环境
                  if (result.updateEnv) {
                    window.location.reload()
                  }
                }
              }
            }
          } else if (res.data.errorCode == '80520103') {
            commit('pageLoading', false)
            type = 'notPermission'
            Router.push({ name: 'remove', query: { type: 'noCommonpartyPermission' } })
          } else if (res.data.errorCode == '80520104') {
            commit('pageLoading', false)
            type = 'notPermission'
            Router.push({ name: 'remove', query: { type: 'noCommonpartyPermission' } })
          } else if (res.data.errorCode == '82201504') {
            commit('pageLoading', false)
            type = 'notExist'
            Router.push({ name: 'remove', query: { type: 'disableParty' } })
          } else {
            commit('pageLoading', false)
            Message.error(i18n.t('common.blockAccount'))
            Router.push({
              name: 'joinOrStart'
            })
          }
        })
        .catch(e => {
          console.log('check failed')
        })
      return type
    },
    async config ({ commit, state }) {
      // initConfig的值建议从store中获取，401/logout时localStorage会被清空
      await axios
        .get('/partyline-backend/publicApi/v3/initConfig')
        .then(res => {
          if (!res) return
          if (res.data.errorCode == '0x0') {
            if (res.data.result && res.data.result.applicationName) handleLocalStorage('set', 'applicationName', res.data.result.applicationName)
            handleLocalStorage('set', 'partylineConfig', res.data.result)
            state.aiBotFeature = res.data.result.features?.voiceCommand
            commit('config', res.data.result)
          }
        })
    },
    async isLogin ({ commit }) {
      return await axios
        .get('/partyline-backend/user/v3/noLogin/loginInfo', { errorTip: false })
        .then(res => {
          if (!res) return
          if (res.data.errorCode == '0x0') {
            commit('saveLoginInfo', res.data.result)
            return true
          } else {
            return false
          }
        }).catch(e => {
          return false
        })
    },
    async removeUserInfo ({ commit }) {
      // 判断用户登录了没有
      commit('saveLoginInfo', {})
    },
    async isMute ({ commit }, data) {
      // 判断用户登录了没有
      commit('isMute', data)
    },
    async showAllowAudio ({ commit }, data) {
      commit('showAllowAudio', data)
    },
    async getBackendVersion ({ commit }) {
      await axios
        .get('/partyline-backend/publicApi/debug/version')
        .then(res => {
          if (!res) return
          const { errorCode, result } = res.data
          if (errorCode === '0x0') {
            handleLocalStorage('set', 'backendVersion', result)
          }
        })
    }
  },
  modules: {}
})
